import { Nav, Tab } from "react-bootstrap";
import { useEditarConfigDeEnvelopeContext } from "..";
import OrSpinner from "../../../../../Components/Utils/OrSpinner";
import DestinatariosConfigEnvelopeSelecionados from "./DestinatariosConfigEnvelopeSelecionados";
import TabelaInserirDestinatarioRelacao from "./TabelaInserirDestinatarioRelacao";
import TabelaInserirDestinatarioUsuario from "./TabelaInserirDestinatarioUsuario";

interface IDestinatariosConfigEnvelopeProps {}

export default function DestinatariosConfigEnvelope(
    props: IDestinatariosConfigEnvelopeProps
) {
    const { destinatariosConfigEnvelope } = useEditarConfigDeEnvelopeContext();
    return (
        <Tab.Container defaultActiveKey="selecionados">
            <Nav variant="pills" className="btn-label-navs g-1">
                <Nav.Item>
                    <Nav.Link
                        className="btn btn-light-primary btn-sm"
                        eventKey="selecionados"
                        href="#"
                    >
                        Selecionados
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link
                        className="btn btn-light-success btn-sm"
                        eventKey="relacao"
                        href="#"
                    >
                        Relação
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link
                        className="btn btn-light-warning btn-sm"
                        eventKey="usuarios"
                        href="#"
                    >
                        Usuários
                    </Nav.Link>
                </Nav.Item>
            </Nav>
            <Tab.Content>
                <OrSpinner
                    loading={destinatariosConfigEnvelope.loading}
                    wrapperLoadingClasses="w-100 d-flex justify-content-center"
                    loadingColor="primary"
                >
                    <Tab.Pane eventKey="selecionados">
                        <DestinatariosConfigEnvelopeSelecionados />
                    </Tab.Pane>
                    <Tab.Pane eventKey="relacao">
                        <TabelaInserirDestinatarioRelacao />
                    </Tab.Pane>
                    <Tab.Pane eventKey="usuarios">
                        <TabelaInserirDestinatarioUsuario />
                    </Tab.Pane>
                </OrSpinner>
            </Tab.Content>
        </Tab.Container>
    );
}
